import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { environment } from '../../../environments/environment';
import { Schaltleitung } from '../../domain/model/schaltleitung';

@Injectable({
    providedIn: 'root',
})
export class KontaktService {
    private http = inject(HttpClient);

    public getKontaktdaten(stadtwerkeId: string): Observable<Schaltleitung[]> {
        let params = new HttpParams();
        params = params.set('stadtwerkeId', stadtwerkeId);

        return this.http.get<Schaltleitung[]>(environment.API_URL + '/kontaktdaten', { params });
    }
}
